import { TrendingUp, Crown, Headset, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const SERVICES = [
  {
    icon: TrendingUp,
    title: "TikTok Keşfet Desteği",
    description:
      "Algoritmayı senin lehine çalıştırmana yardımcı olan stratejik ve teknik destek sağlıyoruz. Canlı yayınlarının yeni izleyicilere ulaşması için yayın saatleri, içerik planı ve etkileşim stratejileri oluşturuyoruz.",
    gradient: "from-[#0047FF]/15 to-[#00F0FF]/15",
    glow: "bg-[#00F0FF]/20",
    iconColor: "text-cyan-300",
    testid: "service-card-kesfet",
  },
  {
    icon: Crown,
    title: "Premium VIP Yönetim",
    description:
      "Sana özel atanan menajerinle profil analizleri, hedef planlaması ve izleyici psikolojisine yönelik profesyonel yayın danışmanlığı alırsın.",
    gradient: "from-[#B829FF]/15 to-[#FF29A8]/15",
    glow: "bg-[#B829FF]/20",
    iconColor: "text-fuchsia-300",
    testid: "service-card-vip",
  },
  {
    icon: Headset,
    title: "7/24 Kesintisiz Destek",
    description:
      "Teknik bir sorun yaşadığında veya tavsiyeye ihtiyaç duyduğunda WhatsApp VIP destek hattımız üzerinden ekibimize ulaşabilirsin. Ekibimiz yayın sürecinin devamlılığını sağlamak için hızlı şekilde destek verir.",
    gradient: "from-[#00FF88]/12 to-[#00F0FF]/12",
    glow: "bg-[#00FF88]/15",
    iconColor: "text-emerald-300",
    testid: "service-card-destek",
  },
];

export default function Services() {
  const goToApply = () => document.getElementById("basvuru")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hizmetler" data-testid="services-section" className="relative py-28 bg-[#070A12]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="max-w-2xl mb-16">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Hizmetlerimiz</span>
            <h2 className="font-display font-700 text-3xl md:text-4xl mt-4 text-white tracking-tight">
              Büyümen İçin Tasarlanmış <span className="text-gradient">Profesyonel Destek</span>
            </h2>
            <p className="mt-5 text-[#A0ABC0] leading-relaxed">
              Yayın kariyerinin her aşamasında yanındayız. Stratejiden teknik desteğe kadar tüm süreçlerde uzman ekibimizle çalışırsın.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 120}>
              <div
                data-testid={s.testid}
                className={`card-lift relative overflow-hidden rounded-3xl border border-white/[0.07] bg-gradient-to-br ${s.gradient} bg-[#0A0E17] p-8 h-full flex flex-col`}
              >
                <div className={`absolute -top-16 -left-16 w-48 h-48 rounded-full ${s.glow} blur-3xl`} />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl border border-white/10 bg-black/30 flex items-center justify-center mb-7">
                    <s.icon size={22} strokeWidth={1.5} className={s.iconColor} />
                  </div>
                  <h3 className="font-display font-700 text-lg text-white mb-4">{s.title}</h3>
                  <p className="text-sm text-[#A0ABC0] leading-relaxed flex-1">{s.description}</p>
                  <button
                    onClick={goToApply}
                    data-testid={`${s.testid}-detail-button`}
                    className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-cyan-300 hover:text-cyan-100 transition-colors group"
                  >
                    Detaylı Bilgi
                    <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
